import React, {useEffect} from 'react';
import AvatarLetters from "./AvatarLetters";
import CustomSwitch from "./Switch";
import Emitter from "../EventEmitter/EventEmitter";
import {ConstantEventEmitter} from "../data/ConstantEventEmitter";
import {AgGridReact} from "ag-grid-react";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import CheckBox from "./ComponentesFormularios/CheckBox";
import IndicadorEstado from "./IndicadorState";
import Tooltip from "@mui/material/Tooltip";
import {useLocation} from "react-router-dom";
import {useSelector} from "react-redux";



const AgGridTable = ({columnDef, dataList, referencia, acciones, avatarKey, height = '75vh', rowSelection = 'single',
                       onRowDataChange, onRowDataUpdated, onSelectionChanged, rowHeight = 40, suppressRowClickSelection = true,
                       onCellValueChanged, getRowStyle, isExternalFilterPresent, doesExternalFilterPass, pagination = true, onGridReady, onRowClicked, isRowSelectable, defaultColDef = {},
                       frameworkComponents = {}}) => {

  let location = useLocation();
  const permissions = useSelector(state => state.permissions);


  useEffect(() => {
    if(referencia.current){
      referencia.current.api.sizeColumnsToFit();
    }
  }, [referencia, columnDef])


  return(

    <div className="ag-theme-balham py-3" style={{height, width: "100%"}}>

      <AgGridReact
        ref={referencia}
        rowHeight={rowHeight}
        animateRows={true}
        getRowStyle={getRowStyle}
        rowSelection={rowSelection}
        rowData={dataList}
        columnDefs={columnDef}
        defaultColDef={defaultColDef}
        onRowDataChanged={onRowDataChange}
        onRowDataUpdated={onRowDataUpdated}
        onSelectionChanged={onSelectionChanged}
        onCellValueChanged={onCellValueChanged }
        suppressRowClickSelection={suppressRowClickSelection}
        isExternalFilterPresent={isExternalFilterPresent}
        doesExternalFilterPass={doesExternalFilterPass}
        pagination={pagination}
        onGridReady={onGridReady}
        onRowClicked={onRowClicked}
        isRowSelectable={isRowSelectable}
        singleClickEdit={true}
        frameworkComponents={{
          ...frameworkComponents,
          tooltipCellComponent:  params => <Tooltip title={params?.value} aria-label={params?.value}><div>{params?.value}</div></Tooltip> ,
          avatarComponent:  params => <AvatarLetters text={params?.node?.data[avatarKey]} /> ,
          accionesComponent:  params => acciones({params}),
          indicadorEstado:  params => <IndicadorEstado state={params?.value}/>,
          switchComponent:  params => permissions[location.pathname]?.U === 'S' ?
                                                    <CustomSwitch state={params?.value} name={`p${params?.node?.data?.id}`}
                                                      handleChange={(name, checked) =>
                                                      Emitter.emit(ConstantEventEmitter.eventSwitchTable, {name, checked, params})} />
                                                      :
                                                     <IndicadorEstado state={params?.value}/>
                                                     ,
          checkboxComponent:  params => {
            return <div className="d-flex align-items-center w-100 h-100 justify-content-center">
                                          <CheckBox value={params?.value} identificador={`${params?.colDef?.field}`} label=""
                                                    onChange={({name, checked}) =>
                                                      Emitter.emit(ConstantEventEmitter.eventCheckBoxTable, {name, checked, params})} />
                                        </div>},
        }}
      >
      </AgGridReact>

    </div>

  )

}

export default AgGridTable;
